'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.List = undefined;

var _themeProvider = require('@spp/theme-provider');

var _List = require('./List');

var _List2 = _interopRequireDefault(_List);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable import/no-named-as-default */
exports.List = _List2.default;
exports.default = (0, _themeProvider.themer)('@spp/ui-list')(_List2.default);
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/hyperion-web-components/~/@spp/ui-list/lib/cjs/index.js
 ** module id = 273
 ** module chunks = 1
 **/